module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "width": "600px",
      "display": "flex",
      "margin-bottom": "10px"
    }
  }, [_c('multiselect', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "options": _vm.brands,
      "multiple": "true",
      "placeholder": "Selecteer een merk",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔"
    },
    on: {
      "input": function($event) {
        _vm.refresh()
      }
    },
    model: {
      value: (_vm.selectedBrand),
      callback: function($$v) {
        _vm.selectedBrand = $$v
      },
      expression: "selectedBrand"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "options": _vm.marketplaces,
      "multiple": "true",
      "placeholder": "Selecteer een marktplaats",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔"
    },
    on: {
      "input": function($event) {
        _vm.refresh()
      }
    },
    model: {
      value: (_vm.selectedMarketplace),
      callback: function($$v) {
        _vm.selectedMarketplace = $$v
      },
      expression: "selectedMarketplace"
    }
  })], 1)]), _vm._v(" "), _c('api-table-block', {
    ref: "productsTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllProducts,
      "default-sort-by": "profit_margin",
      "item-label-singular": "product",
      "item-label-plural": "producten"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.details(data.item)
            }
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "marketplace",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.value) + "\n    ")]
      }
    }, {
      key: "purchase_price",
      fn: function(data) {
        return [(_vm.showPricesInclVat) ? _c('span', [_vm._v(_vm._s(Math.round((data.value * 1.21) * 100) / 100))]) : _c('span', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "price",
      fn: function(data) {
        return [(_vm.showPricesExclVat) ? _c('span', [_vm._v(_vm._s(Math.round((data.value / 1.21) * 100) / 100))]) : _c('span', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "profit_margin",
      fn: function(data) {
        return [(data.value >= 30) ? _c('b', {
          staticClass: "text-success"
        }, [_vm._v(_vm._s(data.value + '%'))]) : _vm._e(), _vm._v(" "), (data.value < 30 && data.value >= 0) ? _c('b', {
          staticClass: "text-warning"
        }, [_vm._v(_vm._s(data.value + '%'))]) : _vm._e(), _vm._v(" "), (data.value < 0) ? _c('b', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(data.value + '%'))]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "before-block-content"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showPricesInclVat),
      expression: "showPricesInclVat"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showPricesInclVat) ? _vm._i(_vm.showPricesInclVat, null) > -1 : (_vm.showPricesInclVat)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showPricesInclVat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showPricesInclVat = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showPricesInclVat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showPricesInclVat = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Incl btw\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showPricesExclVat),
      expression: "showPricesExclVat"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showPricesExclVat) ? _vm._i(_vm.showPricesExclVat, null) > -1 : (_vm.showPricesExclVat)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showPricesExclVat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showPricesExclVat = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showPricesExclVat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showPricesExclVat = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Excl btw\n          ")])])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44edca2f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/reports/ReportProfitMarginPage.vue
// module id = 710
// module chunks = 1